/**
 * Asynchronously loads the component for DashboardsPage
 */

import { lazyLoad } from 'utils/loadable';

export const DashboardsPage = lazyLoad(
  () => import('./index'),
  module => module.DashboardsPage,
);
